import { ModalFooter } from '@modusign/design-system';
import { ReactNode } from 'react';

interface UpSellingModalFooterProps {
  children: ReactNode;
}

export default function UpSellingModalFooter({ children }: UpSellingModalFooterProps) {
  return (
    <ModalFooter mt={0} pb={9} px={9}>
      {children}
    </ModalFooter>
  );
}
